var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMap = function SvgMap(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4444 11.4118L21.2667 11.4294L15.3333 12.6471L8.66667 11.4118L2.4 12.5294C2.16667 12.5706 2 12.6765 2 12.8118V21.7059C2 21.8706 2.24444 22 2.55556 22L2.73333 21.9824L8.66667 20.7647L15.3333 22L21.6 20.8824C21.8333 20.8412 22 20.7353 22 20.6V11.7059C22 11.5412 21.7556 11.4118 21.4444 11.4118ZM15.3333 20.8235L8.66667 19.5824V12.5882L15.3333 13.8294V20.8235Z",
    fill: "#343247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 2C10.2063 2 8.25 3.84118 8.25 6.11765C8.25 9.20588 12.625 14.9412 12.625 14.9412C12.625 14.9412 17 9.20588 17 6.11765C17 3.84118 15.0437 2 12.625 2ZM12.625 7.58824C11.7625 7.58824 11.0625 6.92941 11.0625 6.11765C11.0625 5.30588 11.7625 4.64706 12.625 4.64706C13.4875 4.64706 14.1875 5.30588 14.1875 6.11765C14.1875 6.92941 13.4875 7.58824 12.625 7.58824Z",
    fill: "#343247"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "map.e6f97cd5723062397f116274f9b346f7.svg";